import { render, staticRenderFns } from "./OsFinishedList.vue?vue&type=template&id=371803a9"
import script from "./OsFinishedList.vue?vue&type=script&lang=js"
export * from "./OsFinishedList.vue?vue&type=script&lang=js"
import style0 from "./OsFinishedList.vue?vue&type=style&index=0&id=371803a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports